import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Area } from "types";
import ExerciseEditor from "../../components/ExerciseEditor";
import { SuccessErrorSnackbar } from "../../components/SuccessErrorSnackbar";
import { submitNewExercise } from "../../utils/submitExercise";

export const CreateExercise: React.VFC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: "success" | "error" }>({
    open: false,
    message: "",
    severity: "success",
  });

  return (
    <div>
      <h1>{t("create_exercise.title")}</h1>
      <ExerciseEditor
        isSubmitting={isSubmitting}
        submitButtonText="Create Exercise"
        onSubmit={async data => {
          setIsSubmitting(true);
          try {
            const exerciseId = await submitNewExercise(data);
            if (exerciseId) {
              history.push(`${Area.CreateContent_Exercises}/${exerciseId}`);
            } else {
              setSnackbar({
                open: true,
                message: t("create_exercise.error_message"),
                severity: "error",
              });
            }
          } finally {
            setIsSubmitting(false);
          }
        }}
      />

      <SuccessErrorSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </div>
  );
};
